module.exports = __webpack_public_path__ + "assets/img/4_56_big.6a3c1407.jpg";